var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_center"},[_c('agree-text-index',{attrs:{"has-video":_vm.hasVideo,"country":_vm.country}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }